<template>
  <div v-if="data && config">
    <div class="chart-container" v-for="(phase, index) in config.phases" :key="`${index}_container`">
      <div class="mt-6 mb-4 primaryOutline--text text-subtitle-2">
        {{ phase.toUpperCase() }}
      </div>
      <div :id="`${phase}_container`" class="fill"></div>
      <div class="legends">
        <v-row no-gutters v-if="chart">
          <v-col cols="2" v-for="(val, idx) in config.harmonics_bar_chart_legends" :key="idx" :id="idx">
            <div class="d-flex legend text-caption" :style="{ color: val.color }">
              <div :style="{ background: val.color }" class="legend-color mr-1"></div>
              <div>
                {{ val.label }}
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { LightningChart } from "../services/lightningchart";
import { makeCustomTheme } from "@arction/lcjs-themes";

import { BarChartSorting, ColorHEX } from "@arction/lcjs";

export default {
  name: "BarLightningChart",
  props: {
    data: Array,
    config: Object,
  },
  watch: {
    "$vuetify.theme.dark": {
      handler() {
        this.chart.map((c) => c.dispose());
        this.chart = [];
        this.initialize();
      },
    },
    data: {
      handler() {
        this.chart.map((c) => c.dispose());
        this.chart = [];
        this.initialize();
      },
    },
  },
  data: function () {
    return {
      chart: [],
      lc: null,
      axisX: [],
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize: function () {
      const myCustomTheme = makeCustomTheme({
        isDark: this.$vuetify.theme.dark,
        fontFamily: "Roboto, sans-serif",
        backgroundColor: this.$vuetify.theme.dark ? ColorHEX("#1c1d21") : ColorHEX("#ffffff"),
        textColor: this.$vuetify.theme.dark ? ColorHEX("#ffffffaa") : ColorHEX("1c1d2188"),
        dataColors: [ColorHEX("#c6ced4"), ColorHEX("#42f55d"), ColorHEX("#4275f5")],
        axisColor: this.$vuetify.theme.dark ? ColorHEX("#00000000") : ColorHEX("1c1d2188"),
        gridLineColor: this.$vuetify.theme.dark ? ColorHEX("#303030ff") : ColorHEX("1c1d2122"),
        uiBackgroundColor: this.$vuetify.theme.dark ? ColorHEX("#303030ff") : ColorHEX("ffffff"),
        uiBorderColor: this.$vuetify.theme.dark ? ColorHEX("#303030ff") : ColorHEX("ffffff"),
        dashboardSplitterColor: this.$vuetify.theme.dark ? ColorHEX("#552d2d66") : ColorHEX("ffffff"),
      });

      const lc = LightningChart.initialize();
      this.config.phases.map((phase) => {
        let chart = lc.BarChart({
          theme: myCustomTheme,
          container: `${phase}_container`,
        });

        chart.setDataGrouped(this.config.harmonics_bar_chart_title, this.data[phase]);
        chart.setSorting(BarChartSorting.Alphabetical);
        chart.setTitle("");
        this.chart.push(chart);
      });

      /*
      barChart.setSorting(BarChartSorting.Alphabetical);
      const fillRed = new SolidFill({ color: ColorRGBA(255, 0, 0) });

      // With this, we can override the color of the bars
      // TODO:
      // # Add coloring regarding the data. Keep limit column gray
      // # Margin 10%-100% green, 0%-10% yellow, minus red
      /*
      barChart.getBars().forEach((bar) => {
        console.log(bar.setFillStyle(fillRed));
      });
      */
    },
  },
  beforeDestroy() {
    this.chart.map((c) => c.dispose());
  },
};
</script>

<style lang="scss" scoped>
.chart-container {
  width: auto;
  margin: 0 1rem;
}

.fill {
  width: 800px;
  height: 280px;
  margin: 0 1rem;
}

.legends {
  margin: 0 1rem 2rem;

  .legend {
    cursor: pointer;

    .legend-color {
      border-radius: 50%;
      width: 16px;
      height: 16px;
    }
  }

  .legend.disable {
    color: grey !important;

    .legend-color {
      background-color: grey !important;
    }
  }
}
</style>
